// export const baseURL = "http://35.185.171.45/fe/api";
const protocol = window.location.origin.split('://')[0];
export const baseURL = "https://hydrology.gov.np/gss/api";
// export const baseURL = "http://daq.hydrology.gov.np/api-public";
//export const proxyUrl = "http://hydrology.gov.np";
export const proxyUrl = ".";
// export const cmURL = "http://192.168.5.104:3000";
// export const cmURL = "http://localhost:3000";
export const cmURL = `${protocol}://hydrology.gov.np/cm`;
// export const basinDisplayUrl = 'http://110.44.114.109:3002/#';
export const basinDisplayUrl = 'http://hydrology.gov.np/display/basin/#';
export const standardBasinOrder = ['Mahakali', 'Karnali', 'Babai', 'West Rapti', 'Narayani', 'Bagmati', 'Kamala', 'Koshi', 'Kankai', 'Imja EW Project', 'Biring'];
export const rainfallWarning = {'1': 60, '3': 80, '6': 100, '12': 120, '24': 140, 'Hourly': 60, 'Daily': 140};

export const markers = {
  steady_waterlevel: `${proxyUrl}/images/small_steady_waterlevel.png`,
  warning_steady_waterlevel: `${proxyUrl}/images/small_warning_steady_waterlevel.png`,
  danger_steady_waterlevel: `${proxyUrl}/images/small_danger_steady_waterlevel.png`,
  rising_waterlevel: `${proxyUrl}/images/small_rising_waterlevel.png`,
  warning_rising_waterlevel: `${proxyUrl}/images/small_warning_rising_waterlevel.png`,
  danger_rising_waterlevel: `${proxyUrl}/images/small_danger_rising_waterlevel.png`,
  falling_waterlevel: `${proxyUrl}/images/small_falling_waterlevel.png`,
  warning_falling_waterlevel: `${proxyUrl}/images/small_warning_falling_waterlevel.png`,
  danger_falling_waterlevel: `${proxyUrl}/images/small_danger_falling_waterlevel.png`,
  blue_marker:`${proxyUrl}/images/blue-dot.svg`,
  nepal_flag: `${proxyUrl}/images/nepal_flag.gif`,
  nepal_logo: `${proxyUrl}/images/nepal_logo.png`,
  facebook: `${proxyUrl}/images/facebook.png`,
  twitter: `${proxyUrl}/images/twitter.png`,
  nwp: `${protocol}://mfd.gov.np/mfd.gov.np/_nwp/prec1h_0012.png`,
  mfd: `${proxyUrl}/images/mfd.png`,
};

// export const markers = {
//   steady_waterlevel: 'http://www.hydrology.gov.np/new/hydrology//_files/map_images/steady_waterlevel',
//   warning_steady_waterlevel: 'http://www.hydrology.gov.np/new/hydrology//_files/map_images/warning_steady_waterlevel',
//   danger_steady_waterlevel: 'http://www.hydrology.gov.np/new/hydrology//_files/map_images/danger_steady_waterlevel',
//   rising_waterlevel: 'http://www.hydrology.gov.np/new/hydrology//_files/map_images/rising_waterlevel',
//   warning_rising_waterlevel: 'http://www.hydrology.gov.np/new/hydrology//_files/map_images/warning_rising_waterlevel',
//   danger_rising_waterlevel: 'http://www.hydrology.gov.np/new/hydrology//_files/map_images/danger_rising_waterlevel',
//   falling_waterlevel: 'http://www.hydrology.gov.np/new/hydrology//_files/map_images/falling_waterlevel',
//   warning_falling_waterlevel: 'http://www.hydrology.gov.np/new/hydrology//_files/map_images/warning_falling_waterlevel',
//   danger_falling_waterlevel: 'http://www.hydrology.gov.np/new/hydrology//_files/map_images/danger_falling_waterlevel',
//   blue_marker:'http://maps.gstatic.com/mapfiles/ms2/micons/blue-dot.png'
// };



// WEBPACK FOOTER //
// ./src/libs/config.js